import { Translate } from "react-i18nify";
import { useNavigate } from "react-router";
import { LBtn, LFlex, Transitions } from "@components";
import { NavItems } from "@helpers/navigation";
import { AssessmentShell } from "../components/AssessmentShell";
import { useAppSelector } from "@app/hooks";
import { getInstructionFromStep } from "@helpers/instructionHelper";
import { useEffect, useState } from "react";
import VideoPlayer from "@components/VideoPlayer";
import { sleepFor } from "@helpers/countHelper";

export const AssessmentBeginPracticeRun = (): JSX.Element => {
    const [errorLoadingVideo, setErrorLoadingVideo] = useState(false);
    const [videoIsPlaying, setVideoIsPlaying] = useState(true);
    const [currentCaption, setCurrentCaption] = useState("");

    const navigate = useNavigate();

    const practiceInstruction = useAppSelector((x) =>
        getInstructionFromStep(x.assessmentForm.instructions, "Practice")
    );

    const handleOnEnd = async (): Promise<void> => {
        await sleepFor(2);

        setVideoIsPlaying(false);
    };

    useEffect(() => {
        if (errorLoadingVideo) {
            const instructions = practiceInstruction.instructionText.split(";");

            instructions.forEach((instruction, index) => {
                setTimeout(() => {
                    setCurrentCaption(instruction);
                }, index * 3 * 1000);
            });

            setTimeout(() => {
                void handleOnEnd();
            }, (instructions.length + 1) * 3 * 1000);
        }
    }, [practiceInstruction, errorLoadingVideo]);

    const handleOnVideoError = (): void => {
        setErrorLoadingVideo(true);
    };

    const handleNavigateToTestRun = (): void => {
        navigate(NavItems.Assessments.PracticeTestRun.path);
    };

    return (
        <AssessmentShell micVolume={0} micIsRecording={false}>
            {videoIsPlaying && (
                <>
                    {errorLoadingVideo && (
                        <div className="columns">
                            <div className="column">
                                <Transitions currentCaption={currentCaption} />
                            </div>
                        </div>
                    )}
                    {!errorLoadingVideo && (
                        <VideoPlayer
                            url={practiceInstruction.instructionVideoUrl}
                            onLoadError={handleOnVideoError}
                            onEnd={handleOnEnd}
                        />
                    )}
                </>
            )}
            {!videoIsPlaying && (
                <LFlex alignCenter justifyCenter>
                    <p className="has-text-dark-blue is-size-3">
                        <Translate value="assessments.practiceRound" />
                    </p>
                    <LBtn
                        verticalSpacing="5"
                        isLarge
                        onClick={handleNavigateToTestRun}
                        isBold
                        classes="is-size-2"
                        smallTopBottomMargins
                    >
                        <Translate value="assessments.start" />
                    </LBtn>
                </LFlex>
            )}
        </AssessmentShell>
    );
};
